import createIcon from "components/elements/Icons/create-icon";

export default createIcon("CreditCard", [
  [
    "path",
    {
      d: "M3 3.5H21C22.3808 3.5 23.5 4.61929 23.5 6V18C23.5 19.3808 22.3808 20.5 21 20.5H3C1.61929 20.5 0.5 19.3808 0.5 18V6C0.5 4.61929 1.61929 3.5 3 3.5ZM3 4.5C2.17158 4.5 1.5 5.17158 1.5 6V18C1.5 18.8284 2.17158 19.5 3 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V6C22.5 5.17158 21.8284 4.5 21 4.5H3Z",
    },
  ],
  [
    "path",
    {
      d: "M1 9.5H23C23.2762 9.5 23.5 9.72386 23.5 10C23.5 10.2762 23.2762 10.5 23 10.5H1C0.723852 10.5 0.5 10.2762 0.5 10C0.5 9.72386 0.723859 9.5 1 9.5Z",
    },
  ],
]);
